import StandardGateway from './lib/standard_gateway';

export default class NoopOnReconnectGateway extends StandardGateway {
  reconnectHandler() {
    // Noop so that we can have special reconnect handling
    // We can hook into reconnect by calling backends.onReconnect
  }
}
